<footer>
    <div class="footer">
      <div class="header-container">
        <p> Saint Gabriel Monastery E.O.T.C</p>
        <p>1001 Mullins St. Irving, TX 75061</p>
      </div>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5638.670831821341!2d-96.93631941766016!3d32.82475961601505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e833a3528179f%3A0x863eb735d676ebbe!2s1001%20Mullins%20St%2C%20Irving%2C%20TX%2075061!5e0!3m2!1sen!2sus!4v1594696986411!5m2!1sen!2sus" 
    width="100%" height="175" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
    </div>
    <div class="media-wrapper">
        <div class="social-media">
            <i class="fa-brands fa-facebook-f" style="color: rgb(82, 82, 194);"></i>
            <i class="fa-brands fa-youtube" style="color: red;"></i>
            <i class="fa-brands fa-twitter" style="color: rgb(76, 179, 226);"></i>
           </div>
       <p class="copy-right"> &copy; 2022 StGabriel.com</p>
    </div>
   
   
</footer>
